import {AthleteViewModel} from "../../../domain/common/athlete/athlete-view-model";

export class RelatedEntitiesWidgetAthleteViewModel extends AthleteViewModel {

  get relatedEntitySubText(): String {
    return this.clubName || this.country?.name;
  }
}
